var _class, _SenapsLocationsCatalogItem;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import { computed, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import TerriaError from "../../../Core/TerriaError";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { FeatureInfoTemplateTraits } from "../../../Traits/TraitsClasses/FeatureInfoTraits";
import SenapsLocationsCatalogItemTraits from "../../../Traits/TraitsClasses/SenapsLocationsCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import GeoJsonCatalogItem from "./GeoJsonCatalogItem";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
export class SenapsLocationsStratum extends LoadableStratum(SenapsLocationsCatalogItemTraits) {
  constructor(senapsLocationsCatalogItem, geojsonItem) {
    super();
    this.senapsLocationsCatalogItem = senapsLocationsCatalogItem;
    this.geojsonItem = geojsonItem;
    this.geojsonItem = geojsonItem;
  }
  duplicateLoadableStratum(newModel) {
    return new SenapsLocationsStratum(newModel, this.geojsonItem);
  }
  static async load(senapsLocationsCatalogItem) {
    const locationsUrl = senapsLocationsCatalogItem._constructLocationsUrl();
    function addStreamIds(f, index, streamData) {
      const sd = streamData[index];
      if (sd.count === 0) {
        f.properties.hasStreams = false;
      } else if (sd._embedded !== undefined) {
        f.properties.streamIds = sd._embedded.streams.map(s => s.id);
        f.properties.hasStreams = true;
      }
    }
    try {
      const locationsResponse = await loadJson(proxyCatalogItemUrl(senapsLocationsCatalogItem, locationsUrl, "0d"));
      const locations = locationsResponse._embedded.locations;
      const streamPromises = [];
      for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        const locationId = location.id;
        const streamUrl = proxyCatalogItemUrl(senapsLocationsCatalogItem, senapsLocationsCatalogItem._constructStreamsUrl(locationId), "0d");
        streamPromises.push(loadJson(streamUrl));
      }
      const streamData = await Promise.all(streamPromises);
      const fc = {
        type: "FeatureCollection",
        features: locations.map((site, i) => {
          const f = {
            type: "Feature",
            properties: {
              id: site.id,
              description: site.description,
              endpoint: site._links.self.href,
              hasStreams: null,
              streamIds: []
            },
            geometry: site.geojson
          };
          addStreamIds(f, i, streamData);
          return f;
        })
      };
      const geojsonCatalogItem = new GeoJsonCatalogItem(undefined, senapsLocationsCatalogItem.terria);
      geojsonCatalogItem.setTrait(CommonStrata.definition, "geoJsonData", fc);
      geojsonCatalogItem.setTrait(CommonStrata.definition, "clampToGround", true);
      if (isDefined(senapsLocationsCatalogItem.style)) {
        geojsonCatalogItem.setTrait(CommonStrata.definition, "style", senapsLocationsCatalogItem.style);
      }
      if (!senapsLocationsCatalogItem.url) {
        throw new TerriaError({
          title: i18next.t("models.senaps.retrieveErrorTitle"),
          message: i18next.t("models.senaps.missingSenapsBaseUrl")
        });
      }
      const proxiedBaseUrl = proxyCatalogItemUrl(senapsLocationsCatalogItem, senapsLocationsCatalogItem.url, "0d");
      const featureInfo = createStratumInstance(FeatureInfoTemplateTraits, {
        template: "<h4>".concat(i18next.t("models.senaps.locationHeadingFeatureInfo"), ": {{id}}</h4>\n  <h5 style=\"margin-bottom:5px;\">").concat(i18next.t("models.senaps.availableStreamsHeadingFeatureInfo"), "</h5>\n  {{#hasStreams}}\n    <ul>{{#streamIds}}\n      <li>{{.}}</li>\n    {{/streamIds}}</ul>\n    <br/>\n    <chart\n      identifier='{{id}}'\n      title='{{id}}'\n      sources='").concat(proxiedBaseUrl, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=1440&media=csv&csvheader=false&sort=descending,").concat(proxiedBaseUrl, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=7200&media=csv&csvheader=false&sort=descending'\n      source-names='1d,5d'\n      downloads='").concat(proxiedBaseUrl, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=1440&media=csv&csvheader=false&sort=descending,").concat(proxiedBaseUrl, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=7200&media=csv&csvheader=false&sort=descending'\n      download-names='1d,5d'\n    >\n    </chart>\n  {{/hasStreams}}\n  {{^hasStreams}}\n    <br/><br/>\n  {{/hasStreams}}\n  ")
      });
      senapsLocationsCatalogItem.setTrait(CommonStrata.definition, "featureInfoTemplate", featureInfo);
      (await geojsonCatalogItem.loadMapItems()).throwIfError();
      return new SenapsLocationsStratum(senapsLocationsCatalogItem, geojsonCatalogItem);
    } catch (e) {
      throw TerriaError.from(e, {
        title: i18next.t("models.senaps.retrieveErrorTitle"),
        message: i18next.t(e.statusCode === 401 ? "models.senaps.missingKeyErrorMessage" : "models.senaps.generalErrorMessage")
      });
    }
  }
  get dataSource() {
    return this.geojsonItem;
  }
}
_defineProperty(SenapsLocationsStratum, "stratumName", "SenapsLocations");
StratumOrder.addLoadStratum(SenapsLocationsStratum.stratumName);
let SenapsLocationsCatalogItem = (_class = (_SenapsLocationsCatalogItem = class SenapsLocationsCatalogItem extends MappableMixin(UrlMixin(CatalogMemberMixin(CreateModel(SenapsLocationsCatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return SenapsLocationsCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.senaps.name");
  }
  forceLoadMapItems() {
    return SenapsLocationsStratum.load(this).then(stratum => {
      if (stratum === undefined) return;
      runInAction(() => {
        this.strata.set(SenapsLocationsStratum.stratumName, stratum);
      });
    });
  }
  get geoJsonItem() {
    const stratum = this.strata.get(SenapsLocationsStratum.stratumName);
    return isDefined(stratum) ? stratum.dataSource : undefined;
  }
  get mapItems() {
    if (isDefined(this.geoJsonItem)) {
      return this.geoJsonItem.mapItems.map(mapItem => {
        mapItem.show = this.show;
        return mapItem;
      });
    }
    return [];
  }
  forceLoadMetadata() {
    return Promise.resolve();
  }
  _constructLocationsUrl() {
    if (!this.url) {
      throw new TerriaError({
        title: i18next.t("models.senaps.retrieveErrorTitle"),
        message: i18next.t("models.senaps.missingSenapsBaseUrl")
      });
    }
    const uri = new URI("".concat(this.url, "/locations"));
    if (this.locationIdFilter !== undefined) {
      uri.setSearch("id", this.locationIdFilter);
    }
    uri.setSearch("count", "1000");
    uri.setSearch("expand", "true");
    return uri.toString();
  }
  _constructStreamsUrl(locationId) {
    if (!this.url) {
      throw new TerriaError({
        title: i18next.t("models.senaps.retrieveErrorTitle"),
        message: i18next.t("models.senaps.missingSenapsBaseUrl")
      });
    }
    const uri = new URI("".concat(this.url, "/streams"));
    if (this.streamIdFilter !== undefined) {
      uri.setSearch("id", this.streamIdFilter);
    }
    uri.setSearch("locationid", locationId);
    return uri.toString();
  }
}, _defineProperty(_SenapsLocationsCatalogItem, "type", "senaps-locations"), _SenapsLocationsCatalogItem), _applyDecoratedDescriptor(_class.prototype, "geoJsonItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoJsonItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export default SenapsLocationsCatalogItem;